export default __webpack_public_path__ + "static/media/landing-desktop-04.52270282.png";